export default __webpack_public_path__ + "static/media/Frame-min.01c95238.png";